/* SK FAQ — accordion toggle. Opens/closes answers via aria-expanded (CSS animates). */
(function () {
  function init(root) {
    root.querySelectorAll('.qa-q').forEach(function (btn) {
      if (btn.dataset.skBound) return;
      btn.dataset.skBound = '1';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }
  document.querySelectorAll('.sk-faq').forEach(init);
  // Theme-editor support: re-bind when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.sk-faq') : null;
    if (el) init(el);
  });
})();
